<template>
  <div>
    <div class="infoProductTxt"><span>　　江苏海盟金网信息技术有限公司</span>{{infoProduct}}</div>
    <div v-for="(item, index) in infoBox" :key="index">
      <div class="infotit infotitbg1" :class="index<7 ? `infotitbg${index+1}` : 'infotitbg7'">{{item.tit}}<span>{{item.txt}}</span></div>
      <div class="mainInfoOut">
        <span class="topleft"></span>
        <div class="mainData">
          <div>
            <span class="leftLine"></span>
          </div>
          <div class="rightView">
            <div class="boxes" v-for="(itemsec, indexsec) in item.infoArr" :key="indexsec" @click="popupClick(itemsec.tit)"><span class="indexDiv">{{indexsec < 10 ? `0${indexsec+1}`: indexsec+1}}</span> {{itemsec.nameNew || itemsec.tit}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let typingInterval = null
export default {
  components: {
  },
  data() {
    return {
      infoProductTxt: '',

      infoProduct: '，是一家专注于政府数字化、智能化工程建设的高新技术、双软企业。公司集软件研发、产品设计、系统集成、新媒体制作、项目实施运维于一体，自主研发产品涵盖6大类40多个系统，与央（国）企深度合作，为党政机关提供整体解决方案、全新产品配套及项目实施运营服务。',
      infoBox: [
        {
          tit: '一、社会维稳防控',
          txt: 'SOCIAL STABILITY MAINTENANCE AND PREVENTION',
          infoArr: [
            {tit: '重大决策社会稳定风险评估管理平台', },
            {tit: '社会稳定风险防控治理平台', },
            {tit: '社会维稳综合信息管理系统', },
            {tit: '社会矛盾风险化解防范系统', },
            {tit: '重点信访人员监管系统', },
          ]
        },
        {
          tit: '二、城市燃气安全',
          txt: 'CITY GAS SAFETY',
          infoArr: [
            {tit: '政府监管燃气安全统一平台', },
            {tit: '液化气瓶全链条闭环监管平台', },
            {tit: '燃气经营企业数智化工程', },
            {tit: '天然气管网运行动态监管平台', },
            {tit: '餐饮场所智能设备监测预警平台', },
          ]
        },
        {
          tit: '三、社区居家养老',
          txt: 'COMMUNITY HOME CARE',
          infoArr: [
            {tit: '生态养老服务平台', },
            {tit: '居家养老智能化', },
            {tit: 'AI健康管理服务', },
            {tit: '社区养老之家', },
            {tit: '智慧助残管理平台', },
          ]
        },
        {
          tit: '四、政法数智化',
          txt: 'DIGITALIZATION OF POLITICS AND LAW',
          infoArr: [
            {tit: '政法大数据治理平台', },
            {tit: '市域社会治理管理平台', },
            {tit: '政法综合管理服务平台', },
            {tit: '基层社会治理信息系统', },
            {tit: '政法融合指挥调度平台', },
            {tit: '扫黑除恶常态化管理系统', },
            {tit: '全域网格化信息管理系统', },
          ]
        },
        {
          tit: '五、公安治安防控',
          txt: 'PUBLIC SECURITY AND SAFETY CONTROL',
          infoArr: [
            {tit: '社会重点人员动态管控', },
            {tit: '大数据反恐情报支撑系统', },
            {tit: '通信大数据禁毒情报支撑系统', },
            {tit: '诈骗检测处置系统', nameNew: '电信网络诈骗防范与拦截系统'  },
            {tit: '图信融合算法平台', },
            {tit: '维稳舆情监测系统', },
            {tit: '情指行一体化实战应用平台', },
          ]
        },
        {
          tit: '六、政务管理服务',
          txt: 'GOVERNMENT MANAGEMENT SERVICES',
          infoArr: [
            {tit: '智慧应急管理指挥平台', },
            {tit: '重大项目管理平台', },
            {tit: '政企数字经济服务平台', },
            {tit: '智慧党建管理服务平台', },
            {tit: '数字政务综合管理平台', },
            {tit: '社会信用数字化服务管理系统', },
          ]
        },
        {
          tit: '七、乡村振兴工程',
          txt: 'RURAL REVITALIZATION PROJECT',
          infoArr: [
            {tit: '数字乡村信息化工程', },
            {tit: '乡村综合服务平台', },
            {tit: '乡村电商助农平台', },
            {tit: '平安乡村综合治理平台', },
            {tit: '乡村智能物联平台', },
          ]
        },
        {
          tit: '八、养老机构数智化',
          txt: 'DIGITALIZATION OF NURSING HOMES',
          infoArr: [
            {tit: '养老机构集团化管理系统', },
            {tit: '养老机构运营管理信息化系统', },
            {tit: '养老机构智能化建设', },
            {tit: '智慧食堂管理平台', },
            {tit: '医养结合平台', },
          ]
        },
        {
          tit: '九、数字民政管理',
          txt: 'DIGITAL CIVIL ADMINISTRATION',
          infoArr: [
            {tit: '民政大数据可视化平台', },
            {tit: '智慧民政动态监管系统', },
            {tit: '防返贫监测系统', },
            {tit: '智慧殡葬管理系统', },
            {tit: '社会救助服务系统', },
          ]
        },
        {
          tit: '十、智慧助残服务',
          txt: 'SMART DISABILITY ASSISTANCE SERVICES',
          infoArr: [
            {tit: '助残服务直通车', },
            {tit: '残疾人辅具租赁系统', },
            {tit: '残疾人居家安防平台', },
            {tit: '智能探访服务管理平台', },
            {tit: '残疾儿童康复管理平台', },
          ]
        },
      ]
    }
  },
  watch: {
  },
  mounted() {
    // this.startTyping()
  },
  methods: {
    popupClick(item) {
      let isJupm = true
      switch (item) {
        case '社会稳定风险防控治理体系':
          this.$emit('popupData', item)
          isJupm = false
          break;
      }
      // isJupm ? this.navigator({name: 'detail', query: {title: item}}) : ''
    },
    startTyping() {
      clearInterval(typingInterval);
      let i = 0;
      typingInterval= setInterval(() => {
        if (i < this.infoProduct.length) {
          this.infoProductTxt += this.infoProduct[i];
          i++;
        } else {
          clearInterval(typingInterval);
        }
      }, 100); // 每个字符的显示间隔，可以根据需要调整
    }
  },
  destroyed() {
  }
};
</script>

<style lang="less" scoped>
.infoProductTxt{
  width: 341px;
  height: 211px;
  height: 228px;
  background-image: url('~@/image/paragraphBg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  font-family: MicrosoftYaHei;

  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 0 20px 0 16px;
  padding-top: 26px;
  box-sizing: border-box;
  margin-bottom: 34px;
  span{
    font-weight: bold;
  }
}

.mainInfoOut{
  width: 341px;
  min-height: 312px;
  margin: 0 auto;
  margin-top: 21px;
  margin-bottom: 42px;
  position: relative;
  //background-color: #091a2e58;
  background-image: url("~@/image/popupBg.png");
  background-size: 100% 100%;
  padding-top: 32px;
  padding-left: 12px;
  padding-bottom: 22px;
  box-sizing: border-box;
  .topleft{
    position: absolute;
    width: 24px;
    height: 23px;
    left: 0;
    top: -1px;
    display: block;
    background-image: url("~@/image/paragraphBgAngle.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .mainData{
    display: grid;
    grid-template-columns: 19px 261px;
    grid-gap: 11px;
    >div{
      .leftLine{
        display: block;
        width: 1px;
        box-sizing: border-box;
        height: 98%;
        background-color: #ffffff;
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .rightView{
      .boxes{
        margin-top: 29px;
        width: 299px;
        height: 36px;
        background-image: url("~@/image/paragraphTabBG.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 0 0;
        position: relative;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        //text-indent: 5px;
        padding-left: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        //margin-bottom: 36px;
        //margin-top: 26px;
        &::before{
          width: 19px;
          height: 23px;
          position: absolute;
          content: "";
          top: -23px;
          left: -30px;
          //top: 8px;
          background-image: url("~@/image/localIcon.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .indexDiv{
          height: 36px;
          position: absolute;
          left: 0;
          top: -36px;
          font-size: 17px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #ffffff;
          text-indent: 8px;
          display: flex;
          align-items: flex-end;
          font-family: SourceHanSansCN-Normal;
        }
        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
